/** @format */

import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ prevBg, nextBg, toggleDrawBounds, className = "" }) => (
  <div
    className={`bk-zone bk-bottom ${className}`}
    style={{ display: "block" }}
  >
    <div className="bk-region">
      <div
        className="bk-footer"
        style={{ height: "auto" } /* Spaces override */}
      >
        {/* Lots of stuff removed here */}
        <div className="bk-copy">
          <p onClick={prevBg} style={{ cursor: "pointer" }}>
            Welltower{" "}
          </p>
          <p onClick={nextBg} style={{ cursor: "pointer" }}>
            Inc.{" "}
          </p>
          <p onClick={toggleDrawBounds} style={{ cursor: "pointer" }}>
            ©{" "}
          </p>
          <p>
            <span className="bk-copyright-year">
              {new Date().getUTCFullYear()}
            </span>
            All Rights Reserved
          </p>
          <div className="bk-links">
            <span>|</span>
            <a href="http://welltower.com/terms-of-use/">TERMS OF USE</a>
            <span>|</span>
            <Link to="/privacy-policy">PRIVACY POLICY</Link>
            <span>|</span>
            <Link
              to={(location) => ({
                ...location,
                state: { showCookieConsent: true },
              })}
            >
              DO NOT SELL/SHARE MY PERSONAL INFO
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
